import React from 'react'
import { Power as PowerOnIcon } from '@mui/icons-material'
import styled, { css } from 'styled-components'

import Tooltip from 'components/Tooltip'
import KeyboardAccessible from 'components/KeyboardAccessible'

import { color } from 'styles/colors'

type ConnectedStatusIconProps = {
  isConnected?: boolean
  className?: string
  showToolTip?: boolean
  size?: string
}

const ConnectedStatusIcon = ({ isConnected = false, size = '18px', className = undefined, showToolTip = true }: ConnectedStatusIconProps) => {
  const iconTooltip = `This thermostat is ${isConnected ? 'connected' : 'disconnected'}`

  const statusIcon = !isConnected
    ? <S.PowerOffIcon src="/img/hehm-disconnected.svg" alt="HEHM Disconnected Icon" aria-label="disconnected" $size={size} {...{ className }} />
    : <S.PowerOnIcon aria-label="connected" $size={size} {...{ className }} />

  if (showToolTip) {
    return (
      <Tooltip title={iconTooltip} >
        <S.Container readOnly>
          {statusIcon}
        </S.Container>
      </Tooltip>
    )
  } else {
    return statusIcon
  }
}

export default ConnectedStatusIcon

const iconStyle = (size, iconType) => {
  return css`
    font-size: ${size};
    color: ${color(iconType)};
    border: 1px solid ${color(iconType)};
    border-radius: 50%;
  `
}

const S = {
  Container: styled(KeyboardAccessible)`
    margin-left: 5px;
    padding: 2px 3px 0;
    height: 24px;
    width: 34px;

    svg, img {
      position: unset;
      margin-left: 0;
    }
  `,
  PowerOnIcon: styled(PowerOnIcon).withConfig({
    shouldForwardProp: (prop) => !['$size'].includes(prop)
  })<{ $size?: string }>`
  ${({ $size }) => {
    return iconStyle($size, 'connected')
  }}
  `,
  PowerOffIcon: styled.img.withConfig({
    shouldForwardProp: (prop) => !['$size'].includes(prop)
  })<{ $size?: string }>`
    ${({ $size }) => $size && `width: ${$size}; height: ${$size};`}
  `
}
